import { SVGProps } from 'react'

const ErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02943 13.9706 0 9 0C4.02943 0 0 4.02943 0 9C0.00537891 13.9684 4.03165 17.9946 9 18ZM8.25001 4.5C8.25001 4.08579 8.58579 3.75001 9 3.75001C9.41421 3.75001 9.74999 4.08579 9.74999 4.5V10.5C9.74999 10.9142 9.41421 11.25 9 11.25C8.58579 11.25 8.25001 10.9142 8.25001 10.5V4.5ZM9 13.5C9.41421 13.5 9.74999 13.8358 9.74999 14.25C9.74999 14.6642 9.41421 15 9 15C8.58579 15 8.25001 14.6642 8.25001 14.25C8.25001 13.8358 8.58579 13.5 9 13.5Z"
        fill="white"
      />
    </svg>
  )
}

export default ErrorIcon
